import { HttpClient } from '@angular/common/http';
import { computed, inject, Injectable } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';

import { catchError, of } from 'rxjs';

import { countryFlagUrl, Region } from '@bn/primitives';

import { environment } from '../../../environments/environment';

export interface PopFlag {
  code: string;
  iso: string;
  name: string;
  flagUrl: string;
}

@Injectable({ providedIn: 'root' })
export class GeoService {
  private readonly http = inject(HttpClient);

  private readonly regions = toSignal(this.http.get<Region[]>(`${environment.apiUrl}/region`).pipe(catchError(() => of<Region[]>([]))), {
    initialValue: [] as Region[],
  });

  private readonly regionByCode = computed(() => {
    const map = new Map<string, Region>();
    for (const region of this.regions()) {
      if (region.RegionCode) map.set(region.RegionCode.toLowerCase(), region);
    }
    return map;
  });

  public resolve(code: string): PopFlag {
    const region = this.regionByCode().get(code.toLowerCase());
    const iso = (region?.CountryCode ?? code).toLowerCase();
    return {
      code,
      iso,
      name: region?.NameMedium ?? region?.Name ?? code,
      flagUrl: countryFlagUrl(iso, environment.libsUrl),
    };
  }
}
